export default {
    project(state) {
        return state.project;
    },
    selectedProject(state) {
        return state.selectedProject;
    },
}